export function useCtaEvent() {
  const { gtag } = useGtag()
  const route = useRoute()

  const trackCta = (label: string) => {
    gtag('event', 'cta_click', {
      cta_label: label,
      cta_page: route.path,
    })
  }

  return { trackCta }
}
